import PropTypes from 'prop-types';

RadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  options: PropTypes.array,
};

export function RadioGroup({ onChange, value, options = [] }) {
  const checked = value;

  const onSelected = function (radioValue) {
    if (value !== radioValue) {
      onChange(radioValue);
    }
  };

  return (
    <div className="option_area">
      {options.map((option) => {
        let id = option.value + option.label;
        return (
          <div className="option" key={option.value}>
            <div className="radio_cover">
              <input
                type="radio"
                className="lw_radio"
                id={id}
                value={option.value}
                checked={checked === option.value}
                onChange={() => onSelected(option.value)}
              />
              <label htmlFor={id}>{option.label}</label>
            </div>
          </div>
        );
      })}
    </div>
  );
}
